import Swiper, { Navigation, Pagination } from "swiper"

Swiper.use([Navigation, Pagination])

window.initManufacture = () => {
    const map = document.querySelector("#manufacture-map")

    if (map) {
        // MAP groups
        const paths = document.querySelectorAll(
            "g.sauvignon, g.muscatWhite, g.aligote, g.plat, g.pinotBlanc, g.citrus, g.moldova, g.augustin, g.firstBorn, g.cardinalis, g.saperavi, g.risus, g.clairette, g.redGold, g.cimBlack, g.pinotNoir, g.bianca, g.hopeAzos, g.cabernetSauvignon, g.merlot, g.chardonnay",
        )
        if (document.body.classList.contains("manufacture-page") && paths.length) {
            const mapSwiper = new Swiper(".manufacture-map__slider .swiper-container", {
                navigation: {
                    prevEl: ".manufacture-map__slider .swiper-button-prev",
                    nextEl: ".manufacture-map__slider .swiper-button-next",
                },
                spaceBetween: 20,
                pagination: {
                    type: "fraction",
                    el: ".manufacture-map__slider .swiper-pagination",
                },
                on: {
                    init() {
                        paths[this.activeIndex].classList.add("active")
                    },
                    slideChangeTransitionEnd() {
                        paths.forEach((path) => path.classList.remove("active"))
                        paths[this.activeIndex].classList.add("active")
                    },
                },
            })
            paths.forEach((path, index) => {
                path.addEventListener("click", () => {
                    mapSwiper.slideTo(index)
                })
            })
        }
    }
    // animate lines
    {
        const targets = document.querySelectorAll(".manufacture-line")
        const config = {
            rootMargin: "0px",
            threshold: 0.4,
        }
        const observerCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.children[0].style.transition = "stroke-dashoffset 3s linear"
                    entry.target.children[0].style.strokeDashoffset = 0
                    setTimeout(() => {
                        entry.target.children[0].style.strokeDasharray = "10 10"
                    }, 3500)
                }
            })
        }
        const observer = new IntersectionObserver(observerCallback, config)

        targets.forEach((target) => {
            const length = target.children[0].getTotalLength()
            target.children[0].style.strokeDashoffset = length
            target.children[0].style.strokeDasharray = length
            observer.observe(target)
        })
    }
}




// WEBPACK FOOTER //
// ./src/js/manufacture.js